const NavBack = ({ onClick = () => {} }: { onClick?: () => void }) => (
   <div className="svg back" onClick={onClick} area-label="icon">
      <svg
         width="12"
         height="21"
         viewBox="0 0 12 21"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M2.29586 10.4616L10.8424 1.91513C11.0526 1.70494 11.0526 1.36784 10.8424 1.15764C10.6322 0.947452 10.2951 0.947452 10.0849 1.15764L1.15764 10.0849C0.947452 10.2951 0.947452 10.6322 1.15764 10.8424L10.0849 19.7656C10.188 19.8687 10.3268 19.9243 10.4616 19.9243C10.5965 19.9243 10.7353 19.8727 10.8384 19.7656C11.0486 19.5554 11.0486 19.2183 10.8384 19.0081L2.29586 10.4616Z"
            fill="currentColor"
            stroke="currentColor"
         />
      </svg>
   </div>
);

export default NavBack;
